// use * as styled to import  everything so prettier will format createGlobalStyle
import * as styled from "styled-components";
export const GlobalStyle = styled.createGlobalStyle `
  :root {
    @font-family: 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,;
    @font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,;
    --opendash-header-row-height: 46px;
    --opendash-primary-color: #666767;

    --opendash-logocolor-darkgray: #666767;

    --opendash-color-white: #fff;
    --opendash-color-black: #000;
    --opendash-color-gray: gray;
    --opendash-color-lightblack: #303030;
    --opendash-color-lightgray: #fafafa;
    --opendash-color-darkgray: #999;
    --opendash-color-green: green;
    --opendash-color-red: red;
    --opendash-color-blue: #4186c6;
    --opendash-color-yellow: #d2d532;
    --opendash-color-slider-good: #1e8c00;
    --opendash-color-slider-middle: #ff9900;
    --opendash-color-slider-bad: #8c0000;

    --opendash-padding-10: 10px;
  }

  @media only screen and (max-width: 620px) {
    :root {
      --opendash-padding-10: 0px;
    }
  }

  a,
  .ant-btn-link,
  .ant-typography a {
    color: var(--ant-primary-color);

    &:hover,
    &:not(:disabled):hover {
      color: var(--ant-primary-color-hover);
    }
  }

  .depth-1 {
    background-color: #fdfdfd;
  }

  .depth-0 {
    background-color: #f9f9f9;
  }
`;
//# sourceMappingURL=data:application/json;base64,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